// use * as styled to import  everything so prettier will format createGlobalStyle
import * as styled from "styled-components";
export const GlobalStyle = styled.createGlobalStyle `
  :root {
    @font-family: 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,;
    @font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,;
    --opendash-header-row-height: 46px;
    --opendash-primary-color: #666767;

    --opendash-logocolor-darkgray: #666767;

    --opendash-color-white: #fff;
    --opendash-color-black: #000;
    --opendash-color-gray: gray;
    --opendash-color-lightblack: #303030;
    --opendash-color-lightgray: #fafafa;
    --opendash-color-darkgray: #999;
    --opendash-color-green: green;
    --opendash-color-red: red;
    --opendash-color-blue: #4186c6;
    --opendash-color-yellow: #d2d532;
    --opendash-color-slider-good: #1e8c00;
    --opendash-color-slider-middle: #ff9900;
    --opendash-color-slider-bad: #8c0000;

    --opendash-padding-10: 10px;
  }

  @media only screen and (max-width: 620px) {
    :root {
      --opendash-padding-10: 0px;
    }
  }

  a,
  .ant-btn-link,
  .ant-typography a {
    color: var(--ant-primary-color);

    &:hover,
    &:not(:disabled):hover {
      color: var(--ant-primary-color-hover);
    }
  }

  .depth-1 {
    background-color: #fdfdfd;
  }

  .depth-0 {
    background-color: #f9f9f9;
  }
`;
//# sourceMappingURL=data:application/json;base64,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